import Content from '../../content.js';

namespace('IO.Views.PaymentDeviceTypes', function (exports) {
  'use strict';

  var New = Content.extend({
    dom: {
      SELECT2_FIELD: 'select.select2select:not(#vendor-selector)',
      VENDOR_SELECTOR: 'select#vendor-selector',
      NAME_FIELD: '#payment_device_type_name',
      MODEL_FIELD: '#payment_device_type_model_number',
    },

    events: function () {
      var events = [];

      events['change ' + this.dom.NAME_FIELD] = '_populateModel';

      return events;
    },

    render: function () {
      $(this.el).find(this.dom.SELECT2_FIELD).select2();
      $(this.el)
        .find(this.dom.VENDOR_SELECTOR)
        .select2(
          window.select2Defaults({
            acceptNotFound: true,
            allowClear: true,
            placeholder: 'None',
          }),
        );

      PropertyTypeMask.applyMasks.call(this);

      if (typeof AffectedStores !== 'undefined' && AffectedStores !== null) {
        new IO.Views.PaymentDeviceTypes.AffectedPaymentDeviceModal({
          wait: true,
        }).open(AffectedStores);
        AffectedStores = null;
      }
    },

    _populateModel: function (e) {
      var model = $(this.dom.MODEL_FIELD);

      if (model.val() == '') {
        model.val($(e.target).val());
      }
    },
  });

  exports.New = New;
});
